import { Typography } from '../../atoms/typography/typography';

export interface CardTitleProps {
  title: string;
}

export const CardTitle = ({ title }: CardTitleProps) => {
  return <Typography variant="textTitleMediumSurface">{title}</Typography>;
};
